import { useEffect, useState } from "react";
import { Gift, Copy, Check, Share2 } from "lucide-react";
import api, { fmtNaira } from "@/lib/api";
import { toast } from "sonner";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referral/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.code);
      setCopied(true);
      toast.success("Code copied!");
      setTimeout(() => setCopied(false), 1500);
    } catch { toast.error("Copy failed"); }
  };

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(data.share_text)}`, "_blank");
  };

  return (
    <div className="bg-gradient-to-br from-kudi-terracotta to-kudi-green rounded-2xl p-5 text-white relative overflow-hidden" data-testid="referral-card">
      <div className="absolute inset-0 noise-overlay opacity-40" aria-hidden />
      <div className="relative">
        <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-semibold">
          <Gift className="w-3.5 h-3.5" /> Earn ₦500 per referral
        </div>
        <div className="mt-2 font-heading text-lg font-bold">Bring a trader friend → both get loan credit.</div>

        <div className="mt-4 bg-white/15 backdrop-blur border border-white/20 rounded-xl p-3 flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-wider opacity-75">Your code</div>
            <div className="font-mono font-bold text-lg tracking-wider truncate" data-testid="ref-code">{data.code}</div>
          </div>
          <button onClick={copy} className="bg-white/20 hover:bg-white/30 rounded-lg p-2 transition shrink-0 ml-2" data-testid="copy-ref-code">
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </button>
        </div>

        <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
          <Stat label="Friends joined" value={data.successful_count} />
          <Stat label="Bonus earned" value={fmtNaira(data.bonus_naira)} />
        </div>

        <button onClick={shareWhatsApp} className="mt-4 w-full bg-white text-kudi-green rounded-full py-2.5 font-semibold flex items-center justify-center gap-2 hover:bg-kudi-cream transition active:scale-[0.98]" data-testid="share-referral-btn">
          <Share2 className="w-4 h-4" /> Share on WhatsApp
        </button>
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="bg-white/10 backdrop-blur rounded-lg px-3 py-2">
      <div className="text-[10px] uppercase opacity-75">{label}</div>
      <div className="font-heading font-bold tabular-nums">{value}</div>
    </div>
  );
}
